import { ArrowRightOutlined, ToolOutlined } from "@ant-design/icons";
import { Alert, Button } from "antd";
import { useGetMyPortalQuery } from "../../service/groupOnboarding.service";
import styles from "./SetupTrackerBanner.module.scss";

/** In-app pointer to the group's onboarding portal, so an admin needn't dig out the emailed link. */
export default function SetupTrackerBanner() {
  const { data, isError } = useGetMyPortalQuery();
  if (isError || !data?.has_portal || data.is_complete) return null;

  const actionNeeded = data.action_needed === true;
  const needsCount = data.action_needed_count ?? 0;
  const actionHeadline =
    needsCount > 1
      ? `Your Nudge onboarding needs ${needsCount} things from you`
      : data.current_step_title
        ? `Your Nudge onboarding needs one thing from you: ${data.current_step_title}`
        : "Your Nudge onboarding needs one thing from you";
  return (
    <Alert
      type={actionNeeded ? "warning" : "info"}
      showIcon
      icon={<ToolOutlined />}
      closable
      className={styles.banner}
      message={
        <span className={styles.text}>
          <strong>
            {actionNeeded ? actionHeadline : `Nudge onboarding — ${data.completed} of ${data.total} steps done`}
          </strong>
          <span className={styles.muted}>
            {actionNeeded ? " — open it to see what we're waiting on." : " — nothing needed from you right now."}
          </span>
        </span>
      }
      action={
        <Button size="small" type="primary" href={data.url} target="_blank" rel="noopener noreferrer">
          Open onboarding <ArrowRightOutlined />
        </Button>
      }
    />
  );
}
